module.exports = __webpack_public_path__ + "static/media/mobile-animation.b14790a1.gif";